<template>
  <div>
    <div class="rj-page-card__title" style="margin-top: 15px">
      审批记录
    </div>
    <el-table :data="tableData" max-height="300px">
      <el-table-column type="index" label="序号" width="50px" align="left" />
      <el-table-column prop="approver" label="审批人" align="left" />
      <el-table-column prop="approvalOpinion" label="审批内容" align="left" />
      <el-table-column prop="nodeStatus" label="同意/驳回" align="left" />
      <el-table-column prop="approvalTime" label="审批时间" align="left" />
    </el-table>
  </div>
</template>
<script type="es6">

export default {
  data () {
    return {
      tableData: []
    };
  },
  props: {

  },
  components: {
  },
  computed: {

  },
  methods: {
    setData (data) {
      this.tableData = data;
    }
  },
  mounted () {
  }
};
</script>
<style lang="scss" scoped>
:deep(.el-table){
  border: 1px solid #eef0f3 !important;
  border-bottom: 0 !important;
}
:deep(.el-table th){
  border-right: 0 !important;
}
</style>
